(function (w) {
	"use strict";

	function getSbjsSafe() {
		try { return (w.sbjs && sbjs.get) ? sbjs.get : null; } catch (e) { return null; }
	}

	function getWsjsExtraSafe() {
		try { return (w.wsjs_extra && wsjs_extra.get) ? wsjs_extra.get() : null; } catch (e) { return null; }
	}

	w.WSAttribIntegrations = {
		capture: function () {
			return { sb: getSbjsSafe(), extra: getWsjsExtraSafe() };
		}
	};
})(window);